const AwardAchievement =
  "https://assets.deepsoulai.com/about-company-story/award_achievement.jpg";
const esg1 = "https://assets.deepsoulai.com/news-v2/news06/esg1.jpg";
const esg2 = "https://assets.deepsoulai.com/news-v2/news06/esg2.jpg";
const esg3 = "https://assets.deepsoulai.com/news-v2/news06/esg3.jpg";
const esg4 = "https://assets.deepsoulai.com/news-v2/news06/esg4.jpg";
const esg5 = "https://assets.deepsoulai.com/news-v2/news06/esg5.jpg";
const esg6 = "https://assets.deepsoulai.com/news-v2/news06/esg6.jpg";
const news7_1 = "https://assets.deepsoulai.com/news-v2/news07/news7_1.jpg";
const news7_2 = "https://assets.deepsoulai.com/news-v2/news07/news7_2.jpg";
const news7_3 = "https://assets.deepsoulai.com/news-v2/news07/news7_3.jpg";
const news8_1 = "https://assets.deepsoulai.com/news-v2/news08/news8_1.jpg";
const news8_2 = "https://assets.deepsoulai.com/news-v2/news08/news8_2.jpg";
const news10_1 = "https://assets.deepsoulai.com/news-v2/news10/news10_1.jpg";
const news10_2 = "https://assets.deepsoulai.com/news-v2/news10/news10_2.jpg";
const news10_3 = "https://assets.deepsoulai.com/news-v2/news10/news10_3.jpg";
const news10_4 = "https://assets.deepsoulai.com/news-v2/news10/news10_4.jpg";
const news10_5 = "https://assets.deepsoulai.com/news-v2/news10/news10_5.jpg";
const news10_6 = "https://assets.deepsoulai.com/news-v2/news10/news10_6.jpg";
const esgAwards6 =
  "https://assets.deepsoulai.com/news-v2/news11/esgAwards6.jpeg";
const news11_1 = "https://assets.deepsoulai.com/news-v2/news11/news11_1.jpg";
const q3BackgroundEn =
  "https://assets.deepsoulai.com/news-v2/news14/q3_background_en.png";
const q3BackgroundZh =
  "https://assets.deepsoulai.com/news-v2/news14/q3_background_zh.png";
const MVPLaunch = "https://assets.deepsoulai.com/news-v2/news02/MVPLaunch.jpg";
const sueInterview =
  "https://assets.deepsoulai.com/news-v2/news01/sueInterview.jpg";
const hkfii =
  "https://assets.deepsoulai.com/main-page/partnership/scenes/hkfii_expanded.png";
const hkfiiExpanded =
  "https://assets.deepsoulai.com/news-v2/news03/hkfiiExpanded.png";
const semCover = "https://assets.deepsoulai.com/news-v2/news04/sem_cover.jpg";
const sem1 = "https://assets.deepsoulai.com/news-v2/news04/sem1.jpg";
const sem2 = "https://assets.deepsoulai.com/news-v2/news04/sem2.jpg";
const sem3 = "https://assets.deepsoulai.com/news-v2/news04/sem3.jpg";
const sem4 = "https://assets.deepsoulai.com/news-v2/news04/sem4.jpg";
const sem5 = "https://assets.deepsoulai.com/news-v2/news04/sem5.jpg";
const sem6 = "https://assets.deepsoulai.com/news-v2/news04/sem6.jpg";
const diInterviewCover =
  "https://assets.deepsoulai.com/news-v2/news05/news5_01.jpg";
const seminarPreserved =
  "https://assets.deepsoulai.com/main-page/partnership/scenes/seminar_preserved.jpg";
const dreamImpact =
  "https://assets.deepsoulai.com/main-page/partnership/partners/dream_impact.png";
const teamFormationUrl =
  "https://assets.deepsoulai.com/about-company-story/team_formation.jpg";
const DIint = teamFormationUrl;
const diInterview1 = teamFormationUrl;
const figma = "https://assets.deepsoulai.com/about-company-story/oursky.png";
const deepSoul =
  "https://assets.deepsoulai.com/about-company-story/company_establishment.png";

export const imageMap: Record<string, string> = {
  "https://appconfig.deepsoulai.com/assests/souli_heart.png":
    "https://appconfig.deepsoulai.com/assests/souli_heart.png",
  "https://appconfig.deepsoulai.com/assests/q2_background.png":
    "https://appconfig.deepsoulai.com/assests/q2_background.png",
  "/images/news/2026-q3/q3-background-zh.png": q3BackgroundZh,
  "/images/news/2026-q3/q3-background-en.png": q3BackgroundEn,
  "/images/esgAward/esg1.jpg": esg1,
  "/images/esgAward/esg2.jpg": esg2,
  "/images/esgAward/esg3.jpg": esg3,
  "/images/esgAward/esg4.jpg": esg4,
  "/images/esgAward/esg5.jpg": esg5,
  "/images/esgAward/esg6.jpg": esg6,
  "/images/other/MVPLaunch.png": MVPLaunch,
  "/images/other/sueInterview.jpg": sueInterview,
  "/images/other/hkfii.png": hkfii,
  "/images/other/hkfiiExpanded.png": hkfiiExpanded,
  "/images/other/seminarPreserved.jpg": seminarPreserved,
  "/images/seminar/sem1.jpg": sem1,
  "/images/seminar/sem2.jpg": sem2,
  "/images/seminar/sem3.jpg": sem3,
  "/images/seminar/sem4.jpg": sem4,
  "/images/seminar/sem5.jpg": sem5,
  "/images/seminar/sem6.jpg": sem6,
  "/images/seminar/semCover.jpg": semCover,
  "/images/diInterview/diInterview1.jpg": DIint,
  "/images/diInterview/diInterviewCover.jpg": diInterviewCover,
  "/images/news7/news7_1.jpg": news7_1,
  "/images/news7/news7_2.jpg": news7_2,
  "/images/news7/news7_3.jpg": news7_3,
  "/images/news/news8_1.jpg": news8_1,
  "/images/news/news8_2.jpg": news8_2,
  "/images/news/news10_1.jpg": news10_1,
  "/images/news/news10_2.jpg": news10_2,
  "/images/news/news10_3.jpg": news10_3,
  "/images/news/news10_4.jpg": news10_4,
  "/images/news/news10_5.jpg": news10_5,
  "/images/news/news10_6.jpg": news10_6,
  "/images/news/esgAwards6.jpeg": esgAwards6,
  "/images/news/news11_1.jpg": news11_1,
  seminarPreserved,
  AwardAchievement,
  MVPLaunch,
  sueInterview,
  dreamImpact,
  figma,
  diInterview1,
  hkfii,
  deepSoul,
};
